import $ from 'jquery';
import axios from 'axios';
import { get, has } from 'lodash';

export class GarageAPIService {
  constructor() {
    this.headers = {};

    const $csrf = $('meta[name="csrf-token"]');
    if ($csrf.length) {
      this.headers['X-CSRF-TOKEN'] = $csrf.attr('content');
    }
  }

  /**
   * Adds a car to the list of compared cars
   *
   * @param {Number}        id
   *
   */
  async addVehicle(id) {
    const { data, status } = await axios.post(
      '/api/garage_tool/add',
      { id },
      { headers: this.headers }
    );

    if (status >= 300 && has(data, 'message')) {
      this.#logError(get(data, 'message'));
    }
  }

  /**
   * Removes a car from the list of compared cars
   * and redirects to the page with compared cars if needed
   *
   * @param {Number}        id
   *
   */
  async removeVehicle(id) {
    const { data, status } = await axios.post(
      '/api/garage_tool/remove',
      { id },
      { headers: this.headers }
    );

    if (status >= 300 && has(data, 'message')) {
      this.#logError(get(data, 'message'));
    }
  }

  async clearAll() {
    const { data, status } = await axios.get('/api/garage_tool/clear', { headers: this.headers });

    if (status >= 300 && has(data, 'message')) {
      this.#logError(get(data, 'message'));
    }
  }

  #logError(message) {
    console.error(`❌ ComparisonService Error: ${message}`);
  }
}
